import { FunctionComponent } from 'react';

import styles from './TitleSection.module.sass';
import Separator from '../common/Separator';
import SeelLogoHorizontal from '../../common/logos/SeelLogoHorizontal';

const TitleSection: FunctionComponent = () => {
    return (
        <div className={styles.container}>
            <div className={styles.logo}>
                <SeelLogoHorizontal />
            </div>
            <div className={styles.subTitle}>
                Adding Seel Return Assurance allows you to return eligible items for a refund.
            </div>
            <Separator />
        </div>
    );
};

export default TitleSection;
